// src/navigationSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { config } from "../utils/config";
import { getCookie, setCookie } from "../utils/cookieHandler";

const initialState = {
  token: undefined,
  name: "",
  role: "",
};

export const fetchUserData = async (token) => {
  const url = `${config.apiUrl}/api/users/me`; // Replace this with your actual API endpoint
  const options = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`, // Include the token in the authorization header
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      if (response?.status !== 401) {
        return {
          name: "Error",
          role: "Error",
        };
      }
      return {
        name: "",
        role: "",
      };
    }
    const userData = await response.json();
    return {
      name: userData.first_name + " " + userData.last_name,
      role: userData.role?.id,
    };
  } catch (error) {
    if (error.response?.status !== 401) {
      return {
        name: "Error",
        role: "Error",
      };
    }
    return {
      name: "",
      role: "",
    };
  }
};

// Thunk function to fetch user data from the API
export const fetchUserDataThunk = createAsyncThunk(
  "authentication/fetchUserData",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { token, name } = getState().authentication;
      if (name) {
        return {
          exists: true,
        };
      }
      // Call your API function with authorization header
      const userData = await fetchUserData(token); // Pass token as an argument

      return userData; // Assuming your API returns an object with name and role properties
    } catch (error) {
      // Handle errors
      return rejectWithValue(error.message);
    }
  }
);

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    updateAuthentication: (state, action) => {
      return [...action.payload];
    },
    updateAuthenticationByParam: (state, action) => {
      const { paramName, value } = action.payload;
      return {
        ...state,
        [paramName]: value,
      };
    },
    updateAuthenticationByParams: (state, action) => {
      //const { paramName, value } = action.payload
      return {
        ...state,
        ...action.payload,
      };
    },
    resetAuthentication: (state, action) => {
      setCookie("_AT", "");
      setCookie("_n", "");
      setCookie("_r", "");
      return initialState; // Reset to initial stat
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserDataThunk.fulfilled, (state, action) => {
      const { name, role } = action.payload;

      if (role !== getCookie("_r")) {
        setCookie("_r", role);
      }
      if (name === getCookie("_n")) {
        return state;
      } else {
        setCookie("_n", name);
        setCookie("_r", role);
      }
      if (!name) {
        setCookie("_AT", "");
        setCookie("_n", "");
        setCookie("_r", "");
        return initialState; // Reset to initial stat
      }
      return { ...state, name, role };
    });
  },
});

export const {
  updateAuthentication,
  updateAuthenticationByParam,
  updateAuthenticationByParams,
  resetAuthentication,
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
